import { Suspense } from 'react';
import { ListingsClient } from './listings-client';

export default function Page() {
  return (
    <Suspense fallback={null}>
      <ListingsClient />
    </Suspense>
  );
}
